import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';
import { renderFirstName } from '~helpers/common';

import { UserContext } from '~contexts/user';
import { getMutualReview } from '~services/reviews';

import { Suspense } from '~components/suspense';
import FormSkeleton from '~components/forms/skeleton';
import Hero from '~components/hero';

import ReviewModal from './modal';
import ReviewForm from './form';

import './style.scss';

const Review = () => {
  const intl = useIntl();
  const { receiverId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [review, setReview] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const { user } = useContext(UserContext);

  useLayout({ type: 'account', displayCities: false });
  useSeo(intl.formatMessage({ id: 'containers.review.title', defaultMessage: 'Review' }));
  const [isReviewModalOpened, setIsReviewModalOpened] = useState(false);
  const fName = renderFirstName(review?.receiver_first_name);

  useEffect(async () => {
    try {
      const r = await getMutualReview({ authorId: user.personId, receiverId });
      setReview(r);

      // @TODO if no review check if there is a subscription
    } catch (err) {
      setReview(null);
    } finally {
      setIsLoading(false);
      setIsLoaded(true);
    }
  }, []);

  return (
    <div className="c-account__main l-container">
      <Suspense fallback={<FormSkeleton align="center" />} isLoading={isLoading}>
        {isLoaded ? (
          <>
            <Hero.Wrapper>
              <Hero.Title>
                {intl.formatMessage(
                  { id: 'containers.review.headline', defaultMessage: 'Review {firstName}' },
                  { firstName: fName }
                )}
              </Hero.Title>
            </Hero.Wrapper>
            <div className="c-review-page l-center">
              <ReviewModal isOpened={isReviewModalOpened} onToggle={setIsReviewModalOpened} />
              <ReviewForm
                authorId={user.personId}
                receiverId={receiverId}
                score={review?.score}
                comment={review?.text}
                reviewId={review?.id}
                receiverFirstName={fName}
                action={review && review.id ? 'edit' : 'create'}
                isReviewModalOpened={isReviewModalOpened}
                setIsReviewModalOpened={setIsReviewModalOpened}
              />
            </div>
          </>
        ) : (
          <div className="l-center l-error">Could not find cooperation with this user</div>
        )}
      </Suspense>
    </div>
  );
};

export default Review;
